import { render, staticRenderFns } from "./InsightDetails.vue?vue&type=template&id=f68c54f8"
import script from "./InsightDetails.vue?vue&type=script&lang=js"
export * from "./InsightDetails.vue?vue&type=script&lang=js"
import style0 from "./InsightDetails.vue?vue&type=style&index=0&id=f68c54f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports